<p-toast position="top-center"></p-toast>

<app-page-shell>
    @if (isLoading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
    }

    <app-page-hero
        eyebrow="Customs Clearance"
        [title]="isEditMode ? 'Edit Clearance Service' : 'New Clearance Service'"
        subtitle="Define reusable charge lines for brokerage, government outlays, port handling, compliance work, and delivery support.">
        <div actions>
            <p-button type="button" label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                (click)="cancel()"></p-button>
            <p-button type="button" [label]="isEditMode ? 'Update Service' : 'Create Service'" icon="pi pi-save"
                [loading]="isLoading" (click)="save()"></p-button>
        </div>
    </app-page-hero>

    <form [formGroup]="serviceForm" class="service-form p-fluid">
        <app-page-form-section icon="pi pi-list" title="Service Definition"
            subtitle="The base service appears in clearance charge dialogs and can carry default buying and selling amounts.">
            <div class="form-grid">
                <div class="field col-span-2">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="serviceName" pInputText formControlName="serviceName">
                            <label for="serviceName">Service Name *</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-arrow-down"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-inputNumber inputId="buyingAmount" formControlName="buyingAmount" mode="decimal"
                                [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" styleClass="w-full"></p-inputNumber>
                            <label for="buyingAmount">Default Buying Amount</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-arrow-up"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-inputNumber inputId="sellingAmount" formControlName="sellingAmount" mode="decimal"
                                [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" styleClass="w-full"></p-inputNumber>
                            <label for="sellingAmount">Default Selling Amount</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
                <div class="field col-span-3">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <textarea id="description" pInputTextarea rows="4" formControlName="description"></textarea>
                            <label for="description">Description</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-form-section>

        @if (isEditMode) {
            <app-page-form-section icon="pi pi-sitemap" title="Configured Variants"
                subtitle="Variants are shown for visibility and can be maintained through the service variant API in the next UI pass.">
                <p-table [value]="variants" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '48rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Variant</th>
                            <th>Description</th>
                            <th>Buying Adjustment</th>
                            <th>Selling Adjustment</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-variant>
                        <tr>
                            <td>{{ variant.variantName }}</td>
                            <td>{{ variant.description || '-' }}</td>
                            <td>{{ formatAmount(variant.buyingAmountAdjustment) }}</td>
                            <td>{{ formatAmount(variant.sellingAmountAdjustment) }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4">No variants configured for this service.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-page-form-section>
        }

        <div class="form-actions">
            <p-button type="button" label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                (click)="cancel()"></p-button>
            <p-button type="button" [label]="isEditMode ? 'Update Service' : 'Create Service'" icon="pi pi-save"
                [loading]="isLoading" (click)="save()"></p-button>
        </div>
    </form>
</app-page-shell>
